import { getMetaData } from 'common/header/notifications/hooks/mappers/impl/shared';
import { MappedNotification } from 'common/header/notifications/Notifications.types';
import { isNumber } from 'utils/guards';

export const isTimesheetNotification = (notification: MappedNotification) => {
  const metaData = getMetaData(notification);
  return (
    !!notification &&
    isNumber(metaData.numberValue('ACTUAL_COUNT')) &&
    metaData.entityType?.toLocaleLowerCase() === 'timesheets'
  );
};
